module.exports = __webpack_public_path__ + "img/homeBack.1bbe6586.png";